import React from "react";
import styles from "../../Parigi.module.css";

const CrosswordCell = React.forwardRef(({row, col, value, isWrong, onChange, onKeyDown}, ref) => (
    <input
        ref={ref}
        type="text"
        inputMode="text"
        maxLength={1}
        autoComplete="off"
        className={`form-control text-center fw-bold p-0 ${styles.cell} ${isWrong ? styles.cellWrong : ''}`}
        value={value}
        onChange={(e) => onChange(row, col, e.target.value)}
        onKeyDown={(e) => onKeyDown(row, col, e)}
        aria-label={`Cella riga ${row + 1} colonna ${col + 1}`}
    />
));

export default CrosswordCell;
